import React, { Fragment } from "react";
import { Box, Divider, IconButton, Typography, useTheme } from "@mui/material";
import { fileStatus } from "../../DataExplorer/FileExplorer/FilesList/FileStatus";
import { makeStyles } from "tss-react/mui";
import { GradientIconAccent } from "../../../../components/GradientIcon";
import { useThemeSettings } from "../../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  statusCard: {
    flex: 1,
    padding: "16px 24px",
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    borderRadius: 12,
    cursor: "pointer",
    "&:hover": {
      background: theme.palette.action.hover,
    },
  },
  selectedCard: {
    background: theme.palette.background.default,
    boxShadow: "0px 1px 8px 1px rgba(107, 64, 191, 0.16)",
    borderBottom: `4px solid ${theme.palette.accent}`,
    "&:hover": {
      background: theme.palette.background.default,
    },
  },
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function StatusMetrics({ fileStatusCount, selectedStatus, onStatusChange }) {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const theme = useTheme();
  const { classes } = useStyles();
  return (
    <Box px={0.5}>
      <Box
        width={"100%"}
        overflow={"scroll"}
        // mx={1}
        display={"flex"}
        alignItems={"center"}
        borderRadius={4}
        p={0.5}
        bgcolor={theme.palette.background.dark}
        sx={{ border: `1px solid ${theme.palette.divider}` }}>
        {Object.keys(fileStatus).map((status, index, array) => {
          // if (status === "uploaded") return null;
          let displayCount = fileStatusCount[status] || 0;
          if (status === "reviewed") {
            displayCount =
              (fileStatusCount["indexing"] || 0) +
              (fileStatusCount["reviewed"] || 0);
          }
          const Icon = fileStatus[status].icon;
          const isSelected = selectedStatus === status;
          const isBeforeSelected = array[index + 1] === selectedStatus;
          return (
            <Fragment key={status}>
              <Box
                key={status}
                className={`${classes.statusCard} ${
                  isSelected ? classes.selectedCard : ""
                }`}
                onClick={() => onStatusChange(status)}>
                <IconButton
                  sx={{
                    background: isSelected
                      ? isDarkMode ? theme.palette.background.dark : "linear-gradient(314deg, #E8E4FD 16.89%, #FFF 81.91%)"
                      : theme.palette.background.light,
                  }}>
                  {isSelected ? (
                    isDarkMode ? (
                      <Icon sx={{ color: theme.palette.text.primary }} />
                    ) : (
                      <GradientIconAccent Icon={Icon} />
                    )
                  ) : (
                    <Icon sx={{ color: theme.palette.action.active }} />
                  )}
                </IconButton>
                <Box mt={-1}>
                  <Typography variant="h4">{displayCount}</Typography>
                  <Box display={"flex"} alignItems={"center"} gap={0.5}>
                    <Typography variant="label" color="text.secondary">
                      <span className={isSelected ? classes.gradientText : ""}>
                        {status === "all" && "Total"}
                      </span>
                    </Typography>
                    <Typography variant="label" color="text.secondary">
                      <span className={isSelected ? classes.gradientText : ""}>
                        {fileStatus[status].label}
                      </span>
                    </Typography>
                    <Typography variant="label" color="text.secondary">
                      <span className={isSelected ? classes.gradientText : ""}>
                        {status === "all" && "Files"}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {index !== array.length - 1 &&
                !isSelected &&
                !isBeforeSelected && (
                  <Divider orientation="vertical" flexItem sx={{ my: 2 }} />
                )}
            </Fragment>
          );
        })}
      </Box>
    </Box>
  );
}

export default StatusMetrics;
